// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Q53","rootNoMargin":"styles_rootNoMargin__y-pjh"};